import { FilterParams } from '@/types/filter';

// Brand, special offer, search and sort of the full product list. Switching
// category mounts a new list (another page), which takes them over instead
// of starting from scratch.
export interface ListingState {
    filterParams: Pick<FilterParams, 'brand' | 'spec' | 'search'>,
    sortBy: string
}

let current: { owner: object, state: ListingState } | null = null
let carried: { at: number, state: ListingState } | null = null
// A link opened in a new tab never mounts the list here: don't let its state
// surface on some later page
const CARRY_TTL = 5000

// The full list reports its filters and sort after every change
export function rememberListing(owner: object, filterParams: FilterParams, sortBy: string) {
    const { brand, spec, search } = filterParams
    current = { owner, state: { filterParams: { brand, spec, search }, sortBy } }
}

// A new list may be created before the old one is destroyed: only the owner
// clears its own state
export function forgetListing(owner: object) {
    if (current && current.owner === owner) current = null
}

// Right before navigating to another category
export function carryListing() {
    carried = current ? { at: Date.now(), state: current.state } : null
}

// The next full list takes the carried state once
export function takeCarriedListing(): ListingState | null {
    const state = carried && Date.now() - carried.at < CARRY_TTL ? carried.state : null
    carried = null
    return state
}
